import React from "react";
import { Card, FormControlLabel, RadioGroup, Radio, TextField } from "@material-ui/core";
import { useIntl } from "react-intl";
import moment from "moment";
import { DatePicker, MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import ruRU from "date-fns/locale/ru";

import { useStyles } from "../hooks/useStyles";

import { IUser } from "../../../../../interfaces/users";

type TProps = {
  startDate: string;
  setStart: (value: string) => void;
  endDate: string;
  setEnd: (value: string) => void;
  fetch: (params: {
    telegram_id?: string;
    username?: string;
    // role?: string;
    // phone?: string;
    // email?: string;
    date_from?: string;
    date_to?: string;
    page?: number;
    per_page?: number;
  }) => void;
  checkSearch: string;
  user: IUser | null;
  setUser: (value: IUser | null) => void;
  fio: IUser;
  setFio: (value: IUser) => void;
  role: string;
  setCheckSearch: (value: string) => void;
  setRole: (value: string) => void;
  telegramId: string;
  setTelegramId: (value: string) => void;
  username: string;
  setUsername: (value: string) => void;
};

const Filter: React.FC<TProps> = ({
  checkSearch,
  startDate,
  setStart,
  endDate,
  setEnd,
  fetch,
  user,
  fio,
  role,
  setCheckSearch,
  setFio,
  setUser,
  setRole,
  telegramId,
  setTelegramId,
  username,
  setUsername,
}) => {
  const intl = useIntl();
  const classes = useStyles();

  const handleStartDateChange = (date: Date) => {
    setStart(moment(date).format("YYYY-MM-DD"));
    if (endDate && moment(endDate).isBefore(date, "day")) {
      setEnd(moment(date).format("YYYY-MM-DD"));
      fetch({
        page: 1,
        per_page: 20,
        date_from: moment(date).format("YYYY-MM-DD"),
        date_to: moment(date).format("YYYY-MM-DD"),
        telegram_id: checkSearch === "id" ? telegramId : undefined,
        username: checkSearch === "name" ? username : undefined,
        // email: checkSearch === "name" ? fio?.email : undefined,
        // phone: checkSearch === "number" ? user?.phone : undefined,
        // role: role === "all" ? undefined : role,
      });
    } else {
      fetch({
        page: 1,
        per_page: 20,
        date_from: moment(date).format("YYYY-MM-DD"),
        date_to: endDate,
        telegram_id: checkSearch === "id" ? telegramId : undefined,
        username: checkSearch === "name" ? username : undefined,
        // email: checkSearch === "name" ? fio?.email : undefined,
        // phone: checkSearch === "number" ? user?.phone : undefined,
        // role: role === "all" ? undefined : role,
      });
    }
  };

  return (
    <div className={classes.filterColTop}>
      <Card className={classes.card}>
        <RadioGroup
          name="checkSearch"
          value={checkSearch}
          onChange={e => {
            const newValue = e.currentTarget.value;
            newValue && setCheckSearch(newValue);
            setTelegramId("");
            setUsername("");
            fetch({
              page: 1,
              per_page: 20,
              date_from: startDate,
              date_to: endDate,
              // telegram_id: checkSearch === "id" ? telegramId : undefined,
              // username: checkSearch === "name" ? username : undefined,
              // email: checkSearch === "name" ? fio?.email : undefined,
              // phone: checkSearch === "number" ? user?.phone : undefined,
              // role: role === "all" ? undefined : role,
            });
          }}
          style={{ flexDirection: "row" }}
        >
          <FormControlLabel value="id" control={<Radio color="primary" />} label="По Telegram ID" />
          <FormControlLabel value="name" control={<Radio color="primary" />} label="По Telegram username" />
          {/* <FormControlLabel value="name" control={<Radio color="primary" />} label={intl.formatMessage({ id: "AUTH.MAIN.TAB.BY_EMAIL" })} />
          <FormControlLabel value="number" control={<Radio color="primary" />} label={intl.formatMessage({ id: "USER.SEARCH.PHONE" })} /> */}
        </RadioGroup>
        {checkSearch === "id" && (
          <TextField
            value={telegramId}
            onChange={e => {
              const newValue = e.target.value;
              if (!newValue.trim() && newValue !== telegramId) {
                fetch({
                  page: 1,
                  per_page: 20,
                  date_from: startDate,
                  date_to: endDate,
                });
              }
              setTelegramId(newValue);
            }}
            label="ID"
            variant="outlined"
          />
        )}
        {checkSearch === "name" && (
          <TextField
            value={username}
            onChange={e => {
              const newValue = e.target.value;
              if (!newValue.trim() && newValue !== username) {
                fetch({
                  page: 1,
                  per_page: 20,
                  date_from: startDate,
                  date_to: endDate,
                });
              }
              setUsername(newValue);
            }}
            label="Username"
            variant="outlined"
          />
        )}
        <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ruRU}>
          <div className={classes.containerPicker}>
            <DatePicker
              label={intl.formatMessage({ id: "TENDER.DATE.START" })}
              value={startDate}
              format="dd.MM.yyyy"
              inputVariant="outlined"
              onChange={date => {
                handleStartDateChange(date as any);
              }}
              style={{ width: "100%" }}
            />
          </div>
          <div className={classes.containerPicker}>
            <DatePicker
              label={intl.formatMessage({ id: "TENDER.DATE.END" })}
              value={endDate}
              format="dd.MM.yyyy"
              inputVariant="outlined"
              onChange={date => {
                fetch({
                  page: 1,
                  per_page: 20,
                  date_from: startDate,
                  date_to: moment(date).format("YYYY-MM-DD"),
                  telegram_id: checkSearch === "id" ? telegramId : undefined,
                  username: checkSearch === "name" ? username : undefined,
                  // email: checkSearch === "name" ? fio?.email : undefined,
                  // phone: checkSearch === "number" ? user?.phone : undefined,
                  // role: role === "all" ? undefined : role,
                });
                setEnd(moment(date).format("YYYY-MM-DD"));
              }}
              style={{ width: "100%" }}
            />
          </div>
        </MuiPickersUtilsProvider>
      </Card>
    </div>
  );
};

export default Filter;
